import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "slug-settings" }
const _hoisted_2 = { class: "row-center mtop-02" }
const _hoisted_3 = { class: "row-center mtop-04 gap-02" }
const _hoisted_4 = { class: "font-m" }

import { InstituteApi } from "@/apiGenerate/medserver";
import ButtonGroup from "@/components/buttonGroup.vue";
import { medServerApiConfig } from "@/config/medserver-api.config";
import { InstituteErrorCode } from "@/models/institute.model";
import { toastError, toastSuccess } from "@/utils/toast-utils";
import LoadingSpinner from "@/views/loadingSpinner.vue";
import { useClipboard, useDebounceFn } from "@vueuse/core";
import { InputText, useToast } from "primevue";
import { computed, ref, watch } from "vue";
import { useI18n } from "vue-i18n";


export default /*@__PURE__*/_defineComponent({
  __name: 'esInstituteSlugSettings',
  props: {
    instituteId: {},
    inputId: {},
    slug: {}
  },
  emits: ["updateSlug"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const institutApi = new InstituteApi(medServerApiConfig);

const { t } = useI18n();
const { copy, isSupported, copied } = useClipboard({ legacy: true });
const toast = useToast();

const isLoading = ref<boolean>(false);
const slugValue = ref<string>(props.slug);
const errorMessage = ref<string>('');

const fullUrl = computed(() => `${process.env.VUE_APP_PATIENT_INSTITUTE_BASE_URL}/${props.slug}`);

const debounceSaveSlug = useDebounceFn(async (slug: string) => {
    if (!slug) {
        errorMessage.value = t('settings.params.account.institutes.portailPatient.slug.mandatory');
        return;
    }
    
    const isValid = /^[a-zA-Z0-9-]+$/g.test(slug);
    if (!isValid) {
        errorMessage.value = t('settings.params.account.institutes.portailPatient.slug.formatError');
        return;
    }

    isLoading.value = true;
    errorMessage.value = '';
    try {
        await institutApi.updateInstituteSlug({ instituteId: props.instituteId, updateInstituteSlug: { value: slug } });
        emit("updateSlug", slug);
        toastSuccess(toast, {
            summary: t("common.toast.success.update"),
            detail: t("settings.params.account.institutes.portailPatient.slug.success")
        });
    } catch (e) {
        const entries = Object.entries(e);
        const status = entries.find(e => e[0] === 'status');
        if (status && status[1] === InstituteErrorCode.INSTITUTE_SLUG_ALREADY_EXISTS) {
            errorMessage.value = t('settings.params.account.institutes.portailPatient.slug.alreadyUsed');
        } else {
            toastError(toast, {
                summary: t('common.toast.error'),
                detail: t('settings.params.account.institutes.portailPatient.slug.error')
            });
        }
    }
    isLoading.value = false;
}, 500);

const onCopyUrl = () => {
    copy(fullUrl.value);
}

watch(
    slugValue,
    debounceSaveSlug
);

return (_ctx: any,_cache: any) => {
  const _component_text_item = _resolveComponent("text-item")!
  const _component_svg_item = _resolveComponent("svg-item")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_text_item, {
        txt: _unref(t)('settings.params.account.institutes.portailPatient.slug.format'),
        id: `${_ctx.inputId}-description`,
        class: "mtop-02"
      }, null, 8, ["txt", "id"]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(InputText), {
          id: _ctx.inputId,
          type: "text",
          size: "small",
          modelValue: slugValue.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((slugValue).value = $event)),
          class: "w-full",
          disabled: isLoading.value,
          "aria-describedby": `${_ctx.inputId}-error ${_ctx.inputId}-description`,
          required: ""
        }, null, 8, ["id", "modelValue", "disabled", "aria-describedby"]),
        (isLoading.value)
          ? (_openBlock(), _createBlock(LoadingSpinner, {
              key: 0,
              class: "mleft-02",
              logo: false,
              style: 'w-03'
            }))
          : _createCommentVNode("", true)
      ]),
      (errorMessage.value)
        ? (_openBlock(), _createBlock(_component_text_item, {
            key: 0,
            txt: errorMessage.value,
            id: `${_ctx.inputId}-error`,
            class: "mtop-02 main-alert"
          }, null, 8, ["txt", "id"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("span", _hoisted_4, _toDisplayString(fullUrl.value), 1),
      (_unref(isSupported))
        ? (_openBlock(), _createBlock(ButtonGroup, {
            key: 0,
            class: "row-center",
            onClick: onCopyUrl
          }, {
            default: _withCtx(() => [
              (_unref(copied))
                ? (_openBlock(), _createBlock(_component_svg_item, {
                    key: 0,
                    icon: "clipboardChecked",
                    styles: "main-m"
                  }))
                : (_openBlock(), _createBlock(_component_svg_item, {
                    key: 1,
                    icon: "clipboard",
                    styles: "main-m"
                  }))
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})